// SmartFormSection.tsx
import React from 'react';
import GridImages from '@/components/GridImages/GridImages';
import SmartForm from '@/components/SmartForm/SmartForm';
import DownloadButton from '@/components/DownloadButton/DownloadButton';
import { AssetProps } from '@/libs/interfaceProps/assetProps';
import { useTranslations } from 'next-intl';
interface SmartFormSectionProps {
  resId: string;
  responseData: AssetProps;
  params: {
    t: ReturnType<typeof useTranslations>;
    peId?: string;
    lang?: string;
  };
  smartFormRedirectUrl: string;
  globalEnvConfig: {
    NEXT_PUBLIC_USER_TT_URL: string;
    [key: string]: any;
  };
  validationParams?: {
    customerLinks?: boolean;
    leadDropValidation?: boolean;
    peDemandSub?: boolean;
  };
  isLoading: boolean;
  downloadReady: boolean;
  downloadData?: {
    docUrl?: string;
    [key: string]: any;
  };
  resFallbackImage: string;
}

/**
 * SmartFormSection component displays the download form and related information
 * for an asset page.
 */
const SmartFormSection: React.FC<SmartFormSectionProps> = ({
  resId,
  responseData,
  params,
  smartFormRedirectUrl,
  globalEnvConfig,
  validationParams,
  isLoading,
  downloadReady,
  downloadData,
  resFallbackImage
}) => {
  return <div className={'side-panel col-md-12 col-lg-5'} data-sentry-component="SmartFormSection" data-sentry-source-file="SmartFormSection.tsx">
      <div className={'center-panel col-med-12'} id={`resId-${resId}`}>
        <div className={'info-block'}>
          <h2 className={'section-heading'}>
            {params.t('DownloadThis', {
            catname: responseData.docType
          })}
          </h2>
          <div className={'faux-letterbox grid-image-wrap'}>
            <GridImages GridType={'assetDownload'} primarySiteName={responseData.primarySiteName} resId={resId} fallbackimage={resFallbackImage} data-sentry-element="GridImages" data-sentry-source-file="SmartFormSection.tsx" />
          </div>
        </div>
        <div className={'smartform-block mt-2'}>
          <SmartForm resId={resId} peId={params?.peId} hasVendorQuestions={true} language={params?.lang} redirectionUrl={smartFormRedirectUrl} userUrl={globalEnvConfig.NEXT_PUBLIC_USER_TT_URL} customerLink={validationParams?.customerLinks ? responseData?.orgId : ''} isLoading={isLoading} data-sentry-element="SmartForm" data-sentry-source-file="SmartFormSection.tsx" />
          <DownloadButton downloadReady={downloadReady} docData={downloadData} data-sentry-element="DownloadButton" data-sentry-source-file="SmartFormSection.tsx" />
        </div>
      </div>
    </div>;
};
export default SmartFormSection;